export class ClipboardComponent {
    public static SELECTOR = "[data-copy-to-clipboard]";

    public static autoInit(): ClipboardComponent[] {
        const clipboards = document.querySelectorAll(this.SELECTOR) as NodeListOf<HTMLAnchorElement>;
        return Array.from(clipboards).map((clipboard) => new this(clipboard));
    }

    private clipboardElement: HTMLAnchorElement;

    constructor(clipboard: HTMLAnchorElement) {
        this.clipboardElement = clipboard;

        this.addEventListeners();
    }

    private copyToClipboard(event: Event): void {
        event.preventDefault();

        const contentToCopy = this.clipboardElement.href;
        const textArea = document.createElement("textarea");
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.width = "2em";
        textArea.style.height = "2em";
        textArea.style.padding = "0";
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";

        textArea.value = contentToCopy;

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand("copy");
        } catch (exception) {
            // tslint:disable-next-line:no-console
            console.error(exception);
        }

        document.body.removeChild(textArea);
    }

    private addEventListeners(): void {
        this.clipboardElement.addEventListener("click", this.copyToClipboard.bind(this));
    }
}



// WEBPACK FOOTER //
// ./components/clipboard/clipboard.component.ts